import React from 'react';
import styled, { keyframes } from 'styled-components';
import { SPINNER } from '../../../constants/radar';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${SPINNER.BORDER};
  border-top: 4px solid ${SPINNER.ACTIVE};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 16px;
  box-shadow: 0 0 10px ${SPINNER.SHADOW};
`;

const Message = styled.p`
  color: ${SPINNER.TEXT};
  font-size: 14px;
  text-align: center;
  margin: 0;
  font-weight: 500;
`;

const LoadingSpinner = ({ message = 'Loading...' }) => (
  <SpinnerContainer>
    <Spinner />
    <Message>{message}</Message>
  </SpinnerContainer>
);

export default LoadingSpinner; 